<div class="ssh-container">
  <div class="flex flex-row items-center justify-between">
    <div>
      <div class="mat-subtitle-2 fw-600 fs-24">{{viewKeys ? ('INSTANCE_DETAILS.SSH_KEYS' | transloco) : ('INSTANCE_DETAILS.ADD_SSH_KEY' | transloco)}}</div>
      <div class="pt-8">
        <span class="fw-500">{{routeData?.routeName | titlecase}}</span>
        <span class="fw-500 ml-12 vertical-border pl-12">{{'INSTANCE_DETAILS.USER_NAME' | transloco}}:</span>
        <span class="fw-500 pl-4">{{routeData?.overview?.username | titlecase}}</span>
      </div>
    </div>
    <div>
      <mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <mat-divider class="neutral-2 mt-12 mb-12"></mat-divider>
  <div class="pb-32" *ngIf="!viewKeys" [ngClass]="{'disabled': isLoading}">
    <div class="flex items-center">
      <div class="flex header">
        <div class="mat-subtitle-2 fs-14 fw-700 left-header spacing pr-16 pl-12 pt-8 pb-8">{{'INSTANCE_DETAILS.KEY_NAME' | transloco | uppercase}}</div>
        <div class="mat-subtitle-2 fs-14 fw-700 right-header spacing pt-8 pb-8">{{'INSTANCE_DETAILS.KEY' | transloco | uppercase}}</div>
      </div>
      <div class="pl-8">
        <button type="button" [ngClass]="{'disabled': !enableAdd || keyForms?.length === 10}" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-600 add-btn pl-12 pr-12" mat-button (click)="addForm()">
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'INSTANCE_DETAILS.ADD' | transloco }}
        </button>
      </div>
    </div>
    <ng-container *ngFor="let occurrence of occurrences; let i = index">
      <form [formGroup]="keyForms[occurrence]" class="pt-24 media-form">
        <div class="flex flex-row">
          <div *ngIf="!editOption[i] || enableEdit[i]" class="flex flex-col form-fields left-header pr-16">
            <input formControlName="name" placeholder="{{'INSTANCE_DETAILS.ENTER_KEY_NAME' | transloco}}" class="fw-500" required>
            <app-error [control]="keyForms[occurrence]?.get('name')"></app-error>
          </div>
          <div *ngIf="!editOption[i] || enableEdit[i]" class="flex flex-col form-fields right-header mr-32">
            <input formControlName="publicKey" placeholder="{{'INSTANCE_DETAILS.ENTER_KEY' | transloco}}" class="fw-500" required>
            <app-error [control]="keyForms[occurrence]?.get('publicKey')"></app-error>
          </div>
          <div *ngIf="editOption[i] && !enableEdit[i]" class="flex flex-col form-fields left-header pr-16">
            <div class="view-field pl-10 pr-2 flex items-center">
              <span [title]="keyForms[occurrence]?.controls['name']?.value" class="public-key">{{keyForms[occurrence]?.controls['name']?.value}}</span>
            </div>
          </div>
          <div *ngIf="editOption[i] && !enableEdit[i]" class="flex flex-col form-fields right-header mr-32">
            <div class="view-field pl-10 pr-2 flex items-center">
              <mat-icon svgIcon="content_copy" class="icon-md mr-8 cursor-pointer copy-icon" 
                [cdkCopyToClipboard]="keyForms[occurrence]?.controls['publicKey']?.value" (click)="onCopy('Key')"></mat-icon>
              <span [title]="keyForms[occurrence]?.controls['publicKey']?.value" class="public-key">{{keyForms[occurrence]?.controls['publicKey']?.value}}</span>
            </div>
          </div>
          <div>
            <button *ngIf="!editOption[i]" type="button" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-700 cancel-btn btn-height pl-12 pr-12 mr-16" mat-button (click)="cancelKey(keyForms[occurrence], i)">
              {{'BUTTONS.CANCEL' | transloco }}
            </button>
          </div>
          <div>
            <button *ngIf="!editOption[i]" type="button" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-700 tenant-gradient btn-height pl-12 pr-12" mat-button (click)="saveKey(keyForms[occurrence], i)">
              {{'BUTTONS.SAVE' | transloco }}
            </button>
          </div>
          <div *ngIf="editOption[i] && !enableEdit[i]" class="btn-height flex items-center">
            <mat-icon svgIcon="edit" class="cursor-pointer icon-md-1 pr-4" (click)="editOptionClick(keyForms[occurrence], i)"></mat-icon>
          </div>
          <div *ngIf="editOption[i] && !enableEdit[i]" class="btn-height flex items-center">
            <mat-icon svgIcon="delete" class="cursor-pointer icon-md-1 pr-4 delete-icon" (click)="deleteKey(keyForms[occurrence], i)"></mat-icon>
          </div>
          <div>
            <button *ngIf="enableEdit[i]" type="button" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-700 cancel-btn btn-height pl-12 pr-12 mr-16" mat-button (click)="cancelEdit(keyForms[occurrence], i)">
              {{'BUTTONS.CANCEL' | transloco }}
            </button>
          </div>
          <div>
            <button *ngIf="enableEdit[i]" type="button" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-700 tenant-gradient btn-height pl-12 pr-12" mat-button (click)="editKey(keyForms[occurrence], i)">
              {{'BUTTONS.SAVE' | transloco }}
            </button>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <div class="pb-32" *ngIf="!viewKeys && isLoading">
    <mat-card class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
  <div *ngIf="viewKeys">
    <div class="flex items-center">
      <div class="flex header">
        <div class="mat-subtitle-2 fs-14 fw-700 view-left pr-16 pl-12 pt-8 pb-8">{{'INSTANCE_DETAILS.KEY_NAME' | transloco | uppercase}}</div>
        <div class="mat-subtitle-2 fs-14 fw-700 view-right pt-8 pb-8">{{'INSTANCE_DETAILS.KEY' | transloco | uppercase}}</div>
      </div>
    </div>
    <ng-container *ngFor="let sshKey of routeData?.sshPublicKeys; let i = index">
      <div class="flex flex-row pt-16">
        <div class="flex flex-col form-fields view-left pr-16">
          <div class="view-field pl-8 flex items-center">
            <span [title]="sshKey?.name" class="public-key">{{sshKey?.name}}</span>
          </div>
        </div>
        <div class="flex flex-col form-fields view-right">
          <div class="view-field pl-8 pr-8 flex items-center">
            <mat-icon svgIcon="content_copy" class="icon-md mr-8 cursor-pointer copy-icon" 
              [cdkCopyToClipboard]="sshKey?.key" (click)="onCopy('Key')"></mat-icon>
            <span [title]="sshKey?.key" class="public-key">{{sshKey?.key}}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>